module.exports = __webpack_public_path__ + "static/media/close.fbe1667c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/close.png
// module id = 440
// module chunks = 0